import { DirectDebitAttemptsState } from './../reducers/direct.debit.attempts.reducer';
import { COMPLETE_ORDER_FEATURE } from './../reducers/index';
import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromCompleteOrder from '@complete-order/store/reducers';

const getCompleteOrderState =
  createFeatureSelector<fromCompleteOrder.CompleteOrderState>(
    COMPLETE_ORDER_FEATURE
  );

export const getDirectDebitAttemptsState = createSelector(
  getCompleteOrderState,
  (state) => state.directDebitAttempts
);

export const getDirectDebitAttempts = createSelector(
  getDirectDebitAttemptsState,
  (directDebitAttempts: DirectDebitAttemptsState) =>
    directDebitAttempts.data.attempts
);
